/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Group Labels
  laboratory: "Лабораторија",

  // Drawer Header
  drawer_header: {
    app_name: "Iris",
  },

  // Drawer Sections
  drawer_sections: {
    // Operational Section
    operational_section: {
      // Section Title
      title: "Операционен раздел",

      // Operational Items
      drawer_items: {
        channels: {
          title: "Канали",
          tooltip_text: "Набљудување и управување со инструментални врски",
        },
        instruments: {
          title: "Апарати",
          tooltip_text: "Список и конфигурација на апарати",
        },
        validation: {
          title: "Валидација",
          tooltip_text: "Преглед и валидација на QC резултати",
        },
      },
    },

    // Administrative Section
    administrative_section: {
      // Section Title
      title: "Административен раздел",

      // Administrative Items
      drawer_items: {
        locations: {
          title: "Локации",
          tooltip_text: "Управување со локации и LIS мапирања",
        },
        instruments: {
          title: "Апарати",
          tooltip_text: "Список и конфигурација на сите апарати",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "За апликацијата",
          tooltip_text: "Информации за оваа апликација",
        },
      },
    },
  },
};
